
export default function Services() {
  const services = [
    {
      icon: 'ri-scissors-2-line',
      title: 'Dámske strihanie',
      description: 'Moderné strihy prispôsobené vášmu typu vlasov a tvaru tváre. Vytvoríme pre vás účes, ktorý podčiarkne vašu osobnosť.'
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'Pánske strihanie',
      description: 'Klasické aj moderné pánske strihy s dôrazom na detail.'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Detské strihanie',
      description: 'Strihanie detí v príjemnej a priateľskej atmosfére. Trpezlivý prístup a skúsenosti s najmenšími klientmi.'
    },
    {
      icon: 'ri-palette-line',
      title: 'Farbenie vlasov',
      description: 'Profesionálne farbenie kvalitnou kozmetikou. Od jemných odtieňov až po výrazné zmeny farby.'
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Melír / Balayage',
      description: 'Prirodzené zosvetlenie vlasov technikou melír alebo balayage. Vytvoríme efekt slnkom pobozkávaných vlasov.'
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Spoločenské účesy',
      description: 'Elegantné účesy na svadby, plesy a iné slávnostné príležitosti. Konzultácia a skúšobný účes v cene.'
    }
  ];

  return (
    <section id="sluzby" className="py-20 px-4 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Naše služby</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ponúkame komplexné kadernícke služby pre celú rodinu s dôrazom na kvalitu a individuálny prístup
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-amber-100/50"
            >
              <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-amber-700`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
